import React from 'react'
import { MobileActionsRow, MobileActionButton } from './styled'
import { Filter, ListMobile, Map } from '../../assets/icons'

const MobileFilterBar = ({ filtersCount, onOpenFilters, showMap, onToggleView, isMultTurns, isMobile = true }) => (
	<MobileActionsRow>
		<MobileActionButton onClick={onOpenFilters}>
			<Filter />
			{filtersCount ? `Filtros (${filtersCount})` : 'Filtros'}
		</MobileActionButton>
		{isMobile  && (
			showMap ? (
				<MobileActionButton onClick={() => onToggleView(false)}>
					<ListMobile />
					Lista
				</MobileActionButton>
			) : (
				<MobileActionButton onClick={() => onToggleView(true)}>
					<Map />
					Mapa
				</MobileActionButton>
			)
		)}
	</MobileActionsRow>
)

export default MobileFilterBar
